import React from "react";
import { Controller } from "react-hook-form";
import { Box, TextField, Typography } from "@mui/material";
import { FormattedMessage, useIntl } from "react-intl";

export const DescriptionStep = ({ control, errors, watch }) => {
  const intl = useIntl();
  const descriptionValue = watch("description", "");
  const minLength = 10;
  const isBelowMinimum = descriptionValue.length < minLength;

  return (
    <Box>
      <Controller
        name="description"
        control={control}
        rules={{ 
          required: "general.please-add-description",
          minLength: {
            value: minLength,
            message: "general.description-min-length"
          }
        }}
        render={({ field }) => (
          <TextField
            {...field}
            multiline
            rows={6}
            fullWidth
            placeholder={intl.formatMessage({ id: "general.notes-placeholder", defaultMessage: "Anmerkungen..." })}
            variant="outlined"
            error={!!errors.description}
            helperText={
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Typography 
                  variant="caption" 
                  color={isBelowMinimum ? 'error' : 'text.secondary'}
                  sx={{ 
                    fontWeight: isBelowMinimum ? 500 : 400,
                    fontSize: '0.75rem'
                  }}
                >
                  {descriptionValue.length} <FormattedMessage id="general.characters" defaultMessage="Zeichen" />
                  {isBelowMinimum ? (
                    <span> (<FormattedMessage id="general.minimum-required" values={{ minLength }} defaultMessage="mindestens {minLength} erforderlich" />)</span>
                  ) : (
                    <span> <FormattedMessage id="general.checkmark" defaultMessage="✓" /></span>
                  )}
                </Typography>
              </Box>
            }
          />
        )}
      />
    </Box>
  );
};
